export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const BLOG_URL = process.env.REACT_APP_BLOG_URL;
